import { render, staticRenderFns } from "./ReprintComponent.vue?vue&type=template&id=2ee52666&scoped=true"
import script from "./ReprintComponent.vue?vue&type=script&lang=js"
export * from "./ReprintComponent.vue?vue&type=script&lang=js"
import style0 from "./ReprintComponent.vue?vue&type=style&index=0&id=2ee52666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee52666",
  null
  
)

export default component.exports